/*
 * Copyright (c) Worldline 2020.
 */

import axios from 'axios';


const defaultLang = 'en';

function simpleLang(complicatedLang: string): string {
  const idx = complicatedLang.indexOf('-');
  if (idx > 0) {
    return complicatedLang.substr(0, idx);
  }
  return complicatedLang;
}

function setDefaultLang(Vue: any): Promise<string> {
  return axios.get(`assets/${defaultLang}.json`).then((response) => {
    Vue.i18n.add(defaultLang, response.data);
    Vue.i18n.set(defaultLang);
    updatelang(defaultLang);
    return Promise.resolve(defaultLang);
  }).catch((e) => {
    console.error('Error while getting default language translation: ' + defaultLang, e);
    return Promise.resolve(defaultLang);
  });
}

function updatelang(lang: string): void {
  const html = document.documentElement // returns the html tag
  html.setAttribute('lang', lang);
}

export default {
  install: (Vue: any) => {
    Vue.prototype.$languages = {
      changeLanguage(param: string, tenantId: string): any {

        // if any error english will be used
        let language = defaultLang;

        const post: any = {};
        if (param) {
          post.lang = param;
        }

        // try to use language from query param
        return axios.post(`/csc/v0/info`, post, {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        ).then((response: any) => {
          // use tenant response anyway (default lang if )
          language = simpleLang(response.data.lang);
          if (Vue.i18n.locale() !== language) {
            updatelang(language);
            if (!Vue.i18n.localeExists(language)) {
              return axios.get(`assets/${language}.json`).then((response) => {
                Vue.i18n.add(language, response.data);
                Vue.i18n.set(language);
                return Promise.resolve(language);
              }).catch((e) => {
                console.error('Error while getting translation: ' + language, e);
                return setDefaultLang(Vue);
              });
            } else {
              Vue.i18n.set(language);
            }
          }
        }).catch((e: any) => {
          console.error('Error while getting tenant info', e);
          language = defaultLang;
          return setDefaultLang(Vue);
        });
      },
    };
  },
};
